import * as i2$1 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { Input, Component, Injectable, Pipe, Optional, EventEmitter, Output, NgModule } from '@angular/core';
import * as i5$1 from '@angular/forms';
import { FormsModule } from '@angular/forms';
import * as i8 from '@yourcause/common/buttons';
import { ButtonModule } from '@yourcause/common/buttons';
import * as i5 from '@yourcause/common/core-forms';
import { FormControlComponent, CoreFormsModule } from '@yourcause/common/core-forms';
import * as i3 from '@yourcause/common/i18n';
import { I18nModule } from '@yourcause/common/i18n';
import * as i4 from '@yourcause/common/icons';
import { IconsModule } from '@yourcause/common/icons';
import * as i4$1 from '@yourcause/common/typeahead-select';
import { TypeaheadSelectModule } from '@yourcause/common/typeahead-select';
import * as i2 from 'ngx-bootstrap/datepicker';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { isSameDay, isValid, format, formatDistance, isAfter, isBefore, addHours, subHours, startOfDay, endOfDay, addDays, startOfYear, setYear, differenceInYears, subYears, getYear, getDay, isEqual, isSameSecond, set, getMinutes, getHours } from 'date-fns';
import { isEqual as isEqual$1 } from 'lodash';
import * as i2$2 from '@yourcause/common/utils';
import getMonth from 'date-fns/getMonth';
import { enCA, ca, cy, hi, zhTW, zhCN, tr, ro, pt, pl, sv, nl, ms, ko, ja, it, hu, frCA, el, de, cs, ru, fr, es, enGB, da, enUS } from 'date-fns/locale';
import * as i1 from 'ngx-bootstrap/timepicker';
import { TimepickerModule } from 'ngx-bootstrap/timepicker';

class DateRangePickerComponent extends FormControlComponent {
    constructor() {
        super(...arguments);
        this.placeholder = '';
        this.fullRangeStart = new Date('1900-01-01');
        this.fullRangeEnd = new Date('2999-12-31');
    }
    ngOnInit() {
        super.ngOnInit();
        if (this._value && this._value.length === 2) {
            this.formatValue();
        }
    }
    ngOnChanges(changes) {
        if (changes.disabled) {
            this.formatValue();
        }
    }
    formatValue(value = this._value) {
        const hasValue = value &&
            (value instanceof Array) &&
            value.length === 2;
        if (this.disabled && this.hideValueOnDisabled) {
            this._internalValue = [];
        }
        else if (hasValue &&
            (!isSameDay(this.fullRangeStart, value[0])) &&
            (!isSameDay(this.fullRangeEnd, value[1]))) {
            this._internalValue = [
                new Date(value[0]),
                new Date(value[1])
            ];
        }
        else {
            this._internalValue = [
                undefined,
                undefined
            ];
        }
    }
    _doOnChange(value, fromControlChange = false) {
        this.formatValue(value);
        super._doOnChange(value, fromControlChange);
    }
    _onChange(value) {
        if (value && value.length) {
            const parsedStart = new Date(value[0]);
            const parsedEnd = new Date(value[1]);
            super._onChange([parsedStart, parsedEnd]);
        }
        else {
            this._internalValue = null;
            // handles case where we manually clear the date
            super._onChange([this.fullRangeStart, this.fullRangeEnd]);
        }
        this._internalValue = value;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: DateRangePickerComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.2.10", type: DateRangePickerComponent, isStandalone: false, selector: "yc-date-range-picker", inputs: { hideValueOnDisabled: "hideValueOnDisabled", rounded: "rounded", placeholder: "placeholder" }, usesInheritance: true, usesOnChanges: true, ngImport: i0, template: "<div class=\"form-group\"\n  [class.mb-0]=\"noMarginBottom\"\n  [class.ng-invalid]=\"!!(error || customError) && isDirty\">\n\n  <yc-form-label\n    [srOnly]=\"srOnlyLabel\"\n    [name]=\"name\"\n    [label]=\"label\"\n    [description]=\"description\"\n    [tooltipText]=\"tooltipText\"\n    [popoverTemplate]=\"popoverTemplate\"\n    [showQuestionMarkForTooltip]=\"showQuestionMarkForTooltip\"\n    [asteriskForRequired]=\"addRequiredAsterisk\"\n    [customIcon]=\"customLabelIcon\"\n    [customIconTooltip]=\"customLabelIconTooltip\"\n    [customIconClass]=\"customLabelIconClass\">\n  </yc-form-label>\n\n  <div class=\"form-input-wrapper yc-input-icon-right\">\n    <input\n      [disabled]=\"disabled || control?.disabled\"\n      type=\"text\"\n      [id]=\"name\"\n      class=\"yc-component form-control\"\n      [class.form-control-rounded]=\"rounded\"\n      [ngModel]=\"disabled && disabledDisplayValue ?\n        disabledDisplayValue :\n        _internalValue\"\n      [placeholder]=\"placeholder\"\n      bsDaterangepicker\n      #drp=\"bsDaterangepicker\"\n      [bsConfig]=\"{ showWeekNumbers: false }\"\n      (ngModelChange)=\"_onChange($event)\"\n      (focus)=\"this._onFocus($event)\">\n\n    <yc-fa class=\"yc-right-input-icon\"\n      icon=\"calendar\"\n      (click)=\"disabled || control?.disabled ?\n        undefined :\n        drp.show()\">\n    </yc-fa>\n\n    <yc-fa *ngIf=\"control?.status === 'PENDING'\"\n      class=\"yc-input-status-icon\"\n      icon=\"refresh fa-spin\">\n    </yc-fa>\n  </div>\n\n  <yc-form-help-or-error\n    [error]=\"error\"\n    [customError]=\"customError\"\n    [showError]=\"showError\"\n    [showHelp]=\"showHelp\"\n    [help]=\"help\"\n    [helpTextClass]=\"helpTextClass\">\n  </yc-form-help-or-error>\n</div>", styles: [".form-group .yc-input-icon-right .yc-right-input-icon{display:inline;position:absolute;top:48%;right:.5rem;transform:translate(-50%,-50%)}.form-group .yc-input-icon-right input{padding-right:2rem}\n"], dependencies: [{ kind: "directive", type: i2.BsDaterangepickerDirective, selector: "[bsDaterangepicker]", inputs: ["placement", "triggers", "outsideClick", "container", "outsideEsc", "isOpen", "bsValue", "bsConfig", "isDisabled", "minDate", "maxDate", "dateCustomClasses", "daysDisabled", "datesDisabled", "datesEnabled"], outputs: ["onShown", "onHidden", "bsValueChange"], exportAs: ["bsDaterangepicker"] }, { kind: "directive", type: i2.BsDaterangepickerInputDirective, selector: "input[bsDaterangepicker]" }, { kind: "directive", type: i2$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i5.FormLabelComponent, selector: "yc-form-label", inputs: ["name", "label", "srOnly", "description", "tabIndex", "cursorStyle", "tooltipText", "popoverTemplate", "showQuestionMarkForTooltip", "asteriskForRequired", "forRadioButtons", "customIcon", "customIconTooltip", "customIconClass", "forFileUpload", "triggerUpload"] }, { kind: "component", type: i5.FormHelpOrErrorComponent, selector: "yc-form-help-or-error", inputs: ["error", "customError", "showError", "showHelp", "help", "helpTextClass"] }, { kind: "component", type: i4.FontAwesomeComponent, selector: "yc-fa", inputs: ["color", "icon", "tooltipText", "popoverTemplate", "light", "regular", "solid"], outputs: ["onClick"] }, { kind: "directive", type: i5$1.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i5$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i5$1.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: DateRangePickerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'yc-date-range-picker', standalone: false, template: "<div class=\"form-group\"\n  [class.mb-0]=\"noMarginBottom\"\n  [class.ng-invalid]=\"!!(error || customError) && isDirty\">\n\n  <yc-form-label\n    [srOnly]=\"srOnlyLabel\"\n    [name]=\"name\"\n    [label]=\"label\"\n    [description]=\"description\"\n    [tooltipText]=\"tooltipText\"\n    [popoverTemplate]=\"popoverTemplate\"\n    [showQuestionMarkForTooltip]=\"showQuestionMarkForTooltip\"\n    [asteriskForRequired]=\"addRequiredAsterisk\"\n    [customIcon]=\"customLabelIcon\"\n    [customIconTooltip]=\"customLabelIconTooltip\"\n    [customIconClass]=\"customLabelIconClass\">\n  </yc-form-label>\n\n  <div class=\"form-input-wrapper yc-input-icon-right\">\n    <input\n      [disabled]=\"disabled || control?.disabled\"\n      type=\"text\"\n      [id]=\"name\"\n      class=\"yc-component form-control\"\n      [class.form-control-rounded]=\"rounded\"\n      [ngModel]=\"disabled && disabledDisplayValue ?\n        disabledDisplayValue :\n        _internalValue\"\n      [placeholder]=\"placeholder\"\n      bsDaterangepicker\n      #drp=\"bsDaterangepicker\"\n      [bsConfig]=\"{ showWeekNumbers: false }\"\n      (ngModelChange)=\"_onChange($event)\"\n      (focus)=\"this._onFocus($event)\">\n\n    <yc-fa class=\"yc-right-input-icon\"\n      icon=\"calendar\"\n      (click)=\"disabled || control?.disabled ?\n        undefined :\n        drp.show()\">\n    </yc-fa>\n\n    <yc-fa *ngIf=\"control?.status === 'PENDING'\"\n      class=\"yc-input-status-icon\"\n      icon=\"refresh fa-spin\">\n    </yc-fa>\n  </div>\n\n  <yc-form-help-or-error\n    [error]=\"error\"\n    [customError]=\"customError\"\n    [showError]=\"showError\"\n    [showHelp]=\"showHelp\"\n    [help]=\"help\"\n    [helpTextClass]=\"helpTextClass\">\n  </yc-form-help-or-error>\n</div>", styles: [".form-group .yc-input-icon-right .yc-right-input-icon{display:inline;position:absolute;top:48%;right:.5rem;transform:translate(-50%,-50%)}.form-group .yc-input-icon-right input{padding-right:2rem}\n"] }]
        }], propDecorators: { hideValueOnDisabled: [{
                type: Input
            }], rounded: [{
                type: Input
            }], placeholder: [{
                type: Input
            }] } });

const TIMESTAMP_FORMAT = `yyyy-MM-dd'T'HH:mm:ss`;
const DATE_TIME_FORMAT = 'PP hh:mm aa';
const DATE_FORMAT = 'PP';
var DaysOfWeek;
(function (DaysOfWeek) {
    DaysOfWeek[DaysOfWeek["Monday"] = 1] = "Monday";
    DaysOfWeek[DaysOfWeek["Tuesday"] = 2] = "Tuesday";
    DaysOfWeek[DaysOfWeek["Wednesday"] = 3] = "Wednesday";
    DaysOfWeek[DaysOfWeek["Thursday"] = 4] = "Thursday";
    DaysOfWeek[DaysOfWeek["Friday"] = 5] = "Friday";
    DaysOfWeek[DaysOfWeek["Saturday"] = 6] = "Saturday";
    DaysOfWeek[DaysOfWeek["Sunday"] = 0] = "Sunday";
})(DaysOfWeek || (DaysOfWeek = {}));
var Frequency;
(function (Frequency) {
    Frequency[Frequency["Daily"] = 1] = "Daily";
    Frequency[Frequency["Weekly"] = 2] = "Weekly";
    Frequency[Frequency["Monthly"] = 3] = "Monthly";
})(Frequency || (Frequency = {}));
class DateService {
    constructor(i18n, arrayHelper) {
        this.i18n = i18n;
        this.arrayHelper = arrayHelper;
        this.datePlaceholder = '';
        i18n.language$.subscribe(async (lang) => {
            this.setLocale(lang);
        });
    }
    /**
     * Checks if the Date is valid
     *
     * @param date Date to validate
     * @returns true or false
     */
    isDateValid(date) {
        const year = `${date.getFullYear()}`;
        const month = `0${date.getMonth() + 1}`.slice(-2);
        const day = `0${date.getDate()}`.slice(-2);
        const formattedDate = `${year}/${month}/${day}`;
        const parsedDate = new Date(formattedDate);
        return isValid(date)
            && !isNaN(parsedDate.getTime())
            && (`${parsedDate.getFullYear()}` === year
                && `0${parsedDate.getMonth() + 1}`.slice(-2) === month
                && `0${parsedDate.getDate()}`.slice(-2) === day)
            && !year.startsWith('0')
            && year.length === 4;
    }
    /**
     * Sets the Locale object for date-fns to display dates formatted to the user's locale
     *
     * @param lang: Langauge to set
     */
    setLocale(lang) {
        const result = this.adaptLangToDateFns(lang);
        this.locale = result.locale;
        this.datePlaceholder = result.placeholder;
    }
    getDatePattern(locale) {
        const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
        let formatParts;
        try {
            locale = this.i18n.adaptLangKeyForIntl(locale);
            formatParts = new Intl.DateTimeFormat(locale, options).formatToParts();
        }
        catch (e) { }
        if (!!formatParts) {
            return formatParts.map((e) => {
                switch (e.type) {
                    case 'month':
                        return 'MM';
                    case 'day':
                        return 'DD';
                    case 'year':
                        return 'YYYY';
                    default:
                        return e.value;
                }
                ;
            }).join('');
        }
        return '';
    }
    /**
     * Get the date-fns Locale for the given language
     *
     * @param lang: Langauge to set
     * @returns the date-fns Locale from the given langauge
     */
    adaptLangToDateFns(lang) {
        let locale;
        switch (lang) {
            default:
            case 'en-US':
                locale = enUS;
                break;
            case 'da-DK':
                locale = da;
                break;
            case 'en-GB':
                locale = enGB;
                break;
            case 'es-ES':
            case 'es-MX':
                locale = es;
                break;
            case 'fr-FR':
                locale = fr;
                break;
            case 'ru-RU':
                locale = ru;
                break;
            case 'cs-CZ':
                locale = cs;
                break;
            case 'de-DE':
                locale = de;
                break;
            case 'el-GR':
                locale = el;
                break;
            case 'fr-CA':
                locale = frCA;
                break;
            case 'hu-HU':
                locale = hu;
                break;
            case 'it-IT':
                locale = it;
                break;
            case 'ja-JP':
                locale = ja;
                break;
            case 'ko-KR':
                locale = ko;
                break;
            case 'ms-MY':
                locale = ms;
                break;
            case 'nl-NL':
                locale = nl;
                break;
            case 'sv-SE':
                locale = sv;
                break;
            case 'pl-PL':
                locale = pl;
                break;
            case 'pt-PT':
            case 'pt-BR':
                locale = pt;
                break;
            case 'ro-RO':
                locale = ro;
                break;
            case 'tr-TR':
                locale = tr;
                break;
            case 'zh-CHS':
                locale = zhCN;
                break;
            case 'zh-CHT':
                locale = zhTW;
                break;
            case 'hi-IN':
                locale = hi;
                break;
            case 'cy-GB':
                locale = cy;
                break;
            case 'ca-ES':
                locale = ca;
                break;
            case 'en-CA':
                locale = enCA;
                break;
        }
        return {
            locale,
            placeholder: this.getDatePattern(lang)
        };
    }
    /**
     * Formats a date
     *
     * @param _date: Date to format
     * @param _format: Format to display
     * @param locale: Locale to format in
     * @returns the formatted date
     */
    formatDate(_date, _format = DATE_FORMAT, locale = this.locale) {
        if (!!_date) {
            let date = new Date(_date);
            if (!this.isDateValid(date)) {
                date = new Date();
            }
            return format(date, _format, { locale: locale || this.locale });
        }
        return '';
    }
    /**
     * Gets the distance of a date from now, in words ("5 days ago")
     *
     * @param date: Date to evaluate
     * @returns the date distance from now, in words
     */
    getDateDistanceFromNow(date) {
        return formatDistance(new Date(date), new Date(), {
            locale: this.locale,
            addSuffix: true
        });
    }
    /**
     * Determines whether a date is between 2 other dates
     *
     * @param betweenDate: Date to check if it's between the otheres
     * @param startDate: Start of Date Range
     * @param endDate: End of Date Range
     * @returns if the value is between the start and end
     */
    isBetween(betweenDate, startDate, endDate) {
        const dateIsAfterStart = isAfter(new Date(betweenDate), new Date(startDate));
        const dateIsBeforeEnd = isBefore(new Date(betweenDate), new Date(endDate));
        return dateIsAfterStart && dateIsBeforeEnd;
    }
    /**
     * Adapt a given date with the timezone offset
     *
     * @param offset: Timezone Offset
     * @param date: Date to Adapt
     * @param isForSave: Are we adapting for save?
     * @returns the adapted date
     */
    adaptDatesForTimezoneOffset(offset, date, isForSave = false) {
        const timezoneIsUTC = offset === 0;
        const dateWithoutTheZ = new Date(date.replace(/Z$/, ''));
        const todayIsDST = this.isDaylightSavingsTime(new Date());
        const dateSelectedIsDST = this.isDaylightSavingsTime(new Date(date));
        let dateTime = dateWithoutTheZ;
        if (!timezoneIsUTC && dateSelectedIsDST && !todayIsDST) {
            dateTime = addHours(dateWithoutTheZ, isForSave ? -1 : 1);
        }
        else if (!dateSelectedIsDST && todayIsDST) {
            dateTime = addHours(dateWithoutTheZ, isForSave ? 1 : -1);
        }
        if (!isForSave) {
            return addHours(dateTime, offset);
        }
        else {
            return subHours(dateTime, offset);
        }
    }
    /**
     * Does the date fall during daylight savings?
     *
     * @param date: Date to check against
     * @returns if the date falls during daylight savings
     */
    isDaylightSavingsTime(date) {
        const jan = new Date(date.getFullYear(), 0, 1).getTimezoneOffset();
        const jul = new Date(date.getFullYear(), 6, 1).getTimezoneOffset();
        return Math.max(jan, jul) !== date.getTimezoneOffset();
    }
    /**
     * Adapts a given date/time for display or edit
     *
     * @param date: Date to Adapt
     * @param offset: Timezone Offset
     * @param _format: Date Format
     * @returns the adapted date for display
     */
    adaptDateTimeForDisplay(date, offset, _format = DATE_TIME_FORMAT) {
        if (!!date) {
            const dateTime = this.adaptDatesForTimezoneOffset(offset, date, false);
            return this.formatDate(dateTime, _format);
        }
        return '';
    }
    /**
     * Adapts a given date for save
     *
     * @param date: Date to Adapt
     * @param offset: Timeszone Offset
     * @return the adapted date
     */
    adaptDateTimeForSave(date, offset) {
        if (!!date) {
            const dateTime = this.adaptDatesForTimezoneOffset(offset, date, true);
            return this.formatDate(dateTime, TIMESTAMP_FORMAT);
        }
        return '';
    }
    /**
     * Adapt and format the given date with the timzone offset
     *
     * @param date: Date to Format
     * @param offset: Timezone Offset
     * @param _format: Date Format
     * @returns the adapted date, formatted
     */
    applyOffsetAndFormat(date, offset, _format) {
        if (!!date) {
            return this.formatDate(addHours(new Date(date.toString().replace(/Z$/, '')), offset), _format);
        }
        return '';
    }
    /**
     * Adapts a date to the start of the day and formats it
     *
     * @param date: Date to Adapt
     * @returns the very start of the given day
     */
    formatStartOfDay(date) {
        if (!!date) {
            const start = startOfDay(new Date(date));
            return this.formatDate(start, TIMESTAMP_FORMAT);
        }
        return '';
    }
    /**
     * Adapts a date to the start of the day and formats itat
     *
     * @param date: Date
     * @returns the formatted date at the end of the day
     */
    formatEndOfDay(date) {
        if (!!date) {
            return this.formatDate(endOfDay(new Date(date)), TIMESTAMP_FORMAT);
        }
        return '';
    }
    /**
     * Returns a Date instance for the start or end of the given day
     *
     * @param date: Date to Adapt
     * @param isStart: Return start of day instead of end of day
     * @returns Date instance of the start or end of the day
     */
    getStartOrEndOfDayInUtc(date, isStart = true) {
        if (date) {
            const utcDate = this.getDateAsUtc(date);
            return isStart ? startOfDay(utcDate) : endOfDay(utcDate);
        }
        return null;
    }
    /**
     * Return the given date string as a UTC Date
     *
     * @param date: Date to Adapt
     * @returns the Date in UTC
     */
    getDateAsUtc(date) {
        if (date) {
            return new Date(date.toString().replace(/Z$/, ''));
        }
        return null;
    }
    /**
     * Returns the formatted date at the start or end of the day
     *
     * @param date: Date to Format
     * @param isStart: Return start of day instead of end of day
     * @param _format: Date Format
     * @param forApi: If this is for the API, we make sure to pass locale as english
     * @returns the formatted date at the start or end of the day
     */
    getStartOrEndOfDayInUtcFormatted(date, isStart = true, _format = DATE_FORMAT, forApi = false) {
        if (date) {
            const adapted = this.getStartOrEndOfDayInUtc(date, isStart);
            return this.formatDate(adapted, _format, forApi ? enUS : this.locale);
        }
        return '';
    }
    /**
     * Adds x number of days to a given date and formats it
     *
     * @param date: Date to Add to
     * @param numberOfDays: Number of Days to Add
     * @returns the new date, formatted
     */
    returnDatePlusXDays(date, numberOfDays) {
        if (date) {
            const start = startOfDay(new Date(date));
            const withDaysAdded = addDays(start, numberOfDays);
            return this.formatDate(withDaysAdded);
        }
        return '';
    }
    /**
     * Display a formatted date in a given timezone
     *
     * @param date: Date to Adapt
     * @param timezoneOffset: Timezone Offset
     * @param _format: Date Format
     * @returns the formatted date in the timezone
     */
    displayFormattedTimeInTimezone(date, timezoneOffset = 0, _format = DATE_FORMAT) {
        if (date) {
            return this.adaptDateTimeForDisplay(date, timezoneOffset, _format);
        }
        else {
            return '';
        }
    }
    /**
     * Get an array of all months translated
     *
     * @returns an array of all months translated
     */
    getTranslatedMonths() {
        return [
            this.i18n.translate('common:textJanuary', {}, 'January'),
            this.i18n.translate('common:textFebruary', {}, 'February'),
            this.i18n.translate('common:textMarch', {}, 'March'),
            this.i18n.translate('common:textApril', {}, 'April'),
            this.i18n.translate('common:textMay', {}, 'May'),
            this.i18n.translate('common:textJune', {}, 'June'),
            this.i18n.translate('common:textJuly', {}, 'July'),
            this.i18n.translate('common:textAugust', {}, 'August'),
            this.i18n.translate('common:textSeptember', {}, 'September'),
            this.i18n.translate('common:textOctober', {}, 'October'),
            this.i18n.translate('common:textNovember', {}, 'November'),
            this.i18n.translate('common:textDecember', {}, 'December')
        ];
    }
    /**
     * Gets the Frequency Typeahead Options
     *
     * @returns Frequency options
     */
    getFrequencyOptions() {
        return [{
                label: this.i18n.translate('GLOBAL:textDaily', {}, 'Daily'),
                value: Frequency.Daily
            }, {
                label: this.i18n.translate('GLOBAL:textWeekly', {}, 'Weekly'),
                value: Frequency.Weekly
            }, {
                label: this.i18n.translate('GLOBAL:textMonthly', {}, 'Monthly'),
                value: Frequency.Monthly
            }];
    }
    /**
     * Returns the frequency options in map form
     *
     * @returns the frequency map
     */
    getFrequencyMap() {
        const options = this.getFrequencyOptions();
        return options.reduce((acc, option) => {
            return {
                ...acc,
                [option.value]: option.label
            };
        }, {});
    }
    /**
     * Returns an array of Week Typeahead Options
     *
     * @returns the week options
     */
    getWeekOptions() {
        const weekOptions = [];
        for (let i = 1; i < 13; i++) {
            weekOptions.push({
                label: this.i18n.translate(i === 1 ?
                    'common:textEveryWeek' :
                    'common:textEveryXWeeks', {
                    number: i
                }, i === 1 ?
                    'Every week' :
                    'Every __number__ weeks'),
                value: i
            });
        }
        return weekOptions;
    }
    /**
     * Returns an array of Month Typeahead Options
     *
     * @returns an the month options
     */
    getMonthOptions() {
        const monthOptions = [];
        for (let i = 1; i < 13; i++) {
            monthOptions.push({
                label: this.i18n.translate(i === 1 ?
                    'common:textEveryMonth' :
                    'common:textEveryXMonths', {
                    number: i
                }, i === 1 ?
                    'Every month' :
                    'Every __number__ months'),
                value: i
            });
        }
        return monthOptions;
    }
    /**
     * Returns an array of Day of Month Typeahead Options
     *
     * @returns day of month options
     */
    getDayOfMonthOptions() {
        const dayOfMonthOptions = [];
        for (let i = 1; i < 29; i++) {
            dayOfMonthOptions.push({
                label: this.getDayOfMonthLabel(i),
                value: i
            });
        }
        return dayOfMonthOptions;
    }
    /**
     * Returns the translated Day of Month Label
     *
     * @param i: Day of Month
     * @returns the Day of Month Label
     */
    getDayOfMonthLabel(i) {
        switch (i) {
            default:
            case 1:
                return this.i18n.translate('common:text1stOfMonth', {}, '1st of the month');
            case 2:
                return this.i18n.translate('common:text2ndOfMonth', {}, '2nd of the month');
            case 3:
                return this.i18n.translate('common:text3rdOfMonth', {}, '3rd of the month');
            case 4:
                return this.i18n.translate('common:text4thOfMonth', {}, '4th of the month');
            case 5:
                return this.i18n.translate('common:text5thOfMonth', {}, '5th of the month');
            case 6:
                return this.i18n.translate('common:text6thOfMonth', {}, '6th of the month');
            case 7:
                return this.i18n.translate('common:text7thOfMonth', {}, '7th of the month');
            case 8:
                return this.i18n.translate('common:text8thOfMonth', {}, '8th of the month');
            case 9:
                return this.i18n.translate('common:text9thOfMonth', {}, '9th of the month');
            case 10:
                return this.i18n.translate('common:text10thOfMonth', {}, '10th of the month');
            case 11:
                return this.i18n.translate('common:text11thOfMonth', {}, '11th of the month');
            case 12:
                return this.i18n.translate('common:text12thOfMonth', {}, '12th of the month');
            case 13:
                return this.i18n.translate('common:text13thOfMonth', {}, '13th of the month');
            case 14:
                return this.i18n.translate('common:text14thOfMonth', {}, '14th of the month');
            case 15:
                return this.i18n.translate('common:text15thOfMonth', {}, '15th of the month');
            case 16:
                return this.i18n.translate('common:text16thOfMonth', {}, '16th of the month');
            case 17:
                return this.i18n.translate('common:text17thOfMonth', {}, '17th of the month');
            case 18:
                return this.i18n.translate('common:text18thOfMonth', {}, '18th of the month');
            case 19:
                return this.i18n.translate('common:text19thOfMonth', {}, '19th of the month');
            case 20:
                return this.i18n.translate('common:text20thOfMonth', {}, '20th of the month');
            case 21:
                return this.i18n.translate('common:text21stOfMonth', {}, '21st of the month');
            case 22:
                return this.i18n.translate('common:text22ndOfMonth', {}, '22nd of the month');
            case 23:
                return this.i18n.translate('common:text23rdOfMonth', {}, '23rd of the month');
            case 24:
                return this.i18n.translate('common:text24thOfMonth', {}, '24th of the month');
            case 25:
                return this.i18n.translate('common:text25thOfMonth', {}, '25th of the month');
            case 26:
                return this.i18n.translate('common:text26thOfMonth', {}, '26th of the month');
            case 27:
                return this.i18n.translate('common:text27thOfMonth', {}, '27th of the month');
            case 28:
                return this.i18n.translate('common:text28thOfMonth', {}, '28th of the month');
        }
    }
    /**
     * Returns the Day Of Month options in map form
     *
     * @returns the day of month options map
     */
    getDayOfMonthOptionsMap() {
        const options = this.getDayOfMonthOptions();
        return options.reduce((acc, option) => {
            return {
                ...acc,
                [option.value]: option.label
            };
        }, {});
    }
    /**
     * Returns the Day of the Week options in map form
     *
     * @returns the day of the week map
     */
    getDayOfTheWeekOptions() {
        return [{
                label: this.i18n.translate('common:textMonday', {}, 'Monday'),
                value: DaysOfWeek.Monday
            }, {
                label: this.i18n.translate('common:textTuesday', {}, 'Tuesday'),
                value: DaysOfWeek.Tuesday
            }, {
                label: this.i18n.translate('common:textWednesday', {}, 'Wednesday'),
                value: DaysOfWeek.Wednesday
            }, {
                label: this.i18n.translate('common:textThursday', {}, 'Thursday'),
                value: DaysOfWeek.Thursday
            }, {
                label: this.i18n.translate('common:textFriday', {}, 'Friday'),
                value: DaysOfWeek.Friday
            }, {
                label: this.i18n.translate('common:textSaturday', {}, 'Saturday'),
                value: DaysOfWeek.Saturday
            }, {
                label: this.i18n.translate('common:textSunday', {}, 'Sunday'),
                value: DaysOfWeek.Sunday
            }];
    }
    /**
     * Returns the Day of the week options in map form
     *
     * @returns the day of the week options map
     */
    getDayOfTheWeekOptionsMap() {
        const options = this.getDayOfTheWeekOptions();
        return options.reduce((acc, option) => {
            return {
                ...acc,
                [option.value]: option.label
            };
        }, {});
    }
    /**
     * Returns an array of Hour Typeahead Options
     *
     * @returns the hour options
     */
    getHourOptions() {
        return [{
                label: '1:00',
                value: 1
            }, {
                label: '2:00',
                value: 2
            }, {
                label: '3:00',
                value: 3
            }, {
                label: '4:00',
                value: 4
            }, {
                label: '5:00',
                value: 5
            }, {
                label: '6:00',
                value: 6
            }, {
                label: '7:00',
                value: 7
            }, {
                label: '8:00',
                value: 8
            }, {
                label: '9:00',
                value: 9
            }, {
                label: '10:00',
                value: 10
            }, {
                label: '11:00',
                value: 11
            }, {
                label: '12:00',
                value: 12
            }];
    }
    /**
     * Returns the Hours options in map form
     *
     * @returns the hours options map
     */
    getHoursMap() {
        const options = this.getHourOptions();
        return options.reduce((acc, option) => {
            return {
                ...acc,
                [option.value]: option.label
            };
        }, {});
    }
    /**
     * Returns the time in 24 hour format
     *
     * @param hour: Hour to Convert
     * @param isAM: is this AM?
     * @returns the converted time in 24 hour format
     */
    convertTimeInputsTo24Hour(hour, isAM = true) {
        switch (hour) {
            default:
                if (isAM) {
                    return hour;
                }
                return hour + 12;
            case 12:
                if (isAM) {
                    return 0;
                }
                return hour;
        }
    }
    /**
     * Returns the converted hour in non 24 hour format
     *
     * @param hour: Hour to Convert
     * @returns the coverted time in non 24 hour format
     */
    convert24HourTimeToHour(hour) {
        if (hour === 0) {
            return 12;
        }
        else if (hour > 12) {
            return hour - 12;
        }
        return hour;
    }
    /**
     * Returns the Year Typeahead Options
     *
     * @param startingYear: Starting Year
     * @param returnYearAsString: Should the year be returned as a string? Or number?
     * @returns the Year typeahead options
     */
    getYearTypeaheadOptions(startingYear, returnYearAsString = true) {
        const rightNow = new Date();
        const startingYearAdapted = startOfYear(setYear(new Date(), startingYear));
        const numberOfYears = differenceInYears(rightNow, startingYearAdapted);
        const options = [];
        for (let i = numberOfYears; i >= 0; i--) {
            const date = startOfYear(subYears(new Date(), i));
            const year = getYear(date);
            const _startOfYear = startOfYear(date);
            const option = {
                value: returnYearAsString ? _startOfYear.toISOString() : year,
                label: year.toString()
            };
            options.push(option);
        }
        const sorted = this.arrayHelper.sort(options, 'value', true);
        return sorted;
    }
    /**
     * Display Dependent Dates in Sentence Form
     *
     * @param frequency: Frequency
     * @param week: Week
     * @param month: Month
     * @param dayOfMonth: Day of Month
     * @param dayOfWeek: Day of Week
     * @param isAM: is AM?
     * @param hours: Hours
     * @param timezone: Timezone
     * @returns displays the given data in sentence form
     */
    getDependentDatesSentence(frequency, week, month, dayOfMonth, dayOfWeek, isAM, hours, timezone) {
        switch (frequency) {
            case Frequency.Daily:
                return this.getHoursString(hours, isAM, timezone);
            case Frequency.Weekly:
                const daysOfWeekOptionsMap = this.getDayOfTheWeekOptionsMap();
                if (week === 1) {
                    return this.i18n.translate('common:textRepeatsEveryWeekDynamic', {
                        dayOfWeek: daysOfWeekOptionsMap[dayOfWeek],
                        time: this.getHoursString(hours, isAM, timezone)
                    }, 'Repeats every week on __dayOfWeek__ at __time__');
                }
                else {
                    return this.i18n.translate('common:textRepeatsEveryNumberOfWeeksDynamic', {
                        numberOfWeeks: week,
                        dayOfWeek: daysOfWeekOptionsMap[dayOfWeek],
                        time: this.getHoursString(hours, isAM, timezone)
                    }, 'Repeats every __numberOfWeeks__ weeks on __dayOfWeek__ at __time__');
                }
            case Frequency.Monthly:
                const dayOfMonthOptionsMap = this.getDayOfMonthOptionsMap();
                if (month === 1) {
                    return this.i18n.translate('common:textRepeatsEveryMonthDynamic', {
                        dayOfMonth: dayOfMonthOptionsMap[dayOfMonth],
                        time: this.getHoursString(hours, isAM, timezone)
                    }, 'Repeats every month on the __dayOfMonth__ at __time__');
                }
                else {
                    return this.i18n.translate('common:textRepeatsEveryNumberOMonthsDynamic2', {
                        numberOfMonths: month,
                        dayOfMonth: dayOfMonthOptionsMap[dayOfMonth],
                        time: this.getHoursString(hours, isAM, timezone)
                    }, 'Repeats every __numberOfMonths__ months on the __dayOfMonth__ at __time__');
                }
        }
    }
    /**
     * Get the hours string
     *
     * @param hours: Hours
     * @param isAM: is AM?
     * @param timezone: Timezone
     * @returns the hours string
     */
    getHoursString(hours, isAM, timezone) {
        const hoursMap = this.getHoursMap();
        const amOrPmText = this.i18n.translate(isAM ? 'common:textAM' : 'common:textPM', {}, isAM ? 'AM' : 'PM');
        return `${hoursMap[hours]} ${amOrPmText} ${timezone}`;
    }
    /**
     * Checks if the given date is a max date (year = 9999)
     *
     * @param date: Date to check
     * @returns if the date is a max date
     */
    isMaxDate(date) {
        if (!!date) {
            const year = new Date(date).getFullYear();
            return year === 9999;
        }
        return false;
    }
    /**
     * Checks if the given date is a min date (year = 1900)
     * Couldn't use 0001 because javascript can't compare against that number with the leading zeros
     *
     * @param date: Date to check
     * @returns if the date is a min date
     */
    isMinDate(date) {
        if (!!date) {
            const year = new Date(date).getFullYear();
            return year === 1900;
        }
        return false;
    }
    /**
     * We just need the year to be 1900
     * Couldn't use 0001 because javascript can't compare against that number with the leading zeros
     * Don't set to last date of year to avoid timezone issues
     *
     * @returns Max Date
     */
    getMinDate() {
        return new Date('12/01/1900 00:00:00');
    }
    /**
     * We just need the year to be 9999
     * Don't set to last date of year to avoid timezone issues
     *
     * @returns Max Date
     */
    getMaxDate() {
        return new Date('12/01/9999 00:00:00');
    }
    /**
     * Are the 2 given dates the same?
     *
     * @param date1: Date 1
     * @param date2: Date 2
     * @param ignoreTime: Do we care about time?
     * @returns if the dates are the same
     */
    areDatesTheSame(date1, date2, ignoreTime) {
        if (!date1 && !date2) {
            return true;
        }
        else if (!!date1 && !!date2) {
            const _date1 = new Date(date1);
            const _date2 = new Date(date2);
            if (ignoreTime) {
                const monthSame = getMonth(_date1) === getMonth(_date2);
                const daySame = getDay(_date1) === getDay(_date2);
                const yearSame = getYear(_date1) === getYear(_date2);
                return monthSame && daySame && yearSame;
            }
            else {
                return isEqual(_date1, _date2);
            }
        }
        return false;
    }
    /**
     * Is the date in the future?
     *
     * @param date: Date to check
     * @returns if the date is in the future
     */
    isFutureDate(date) {
        const today = new Date();
        const isBeforeToday = isBefore(new Date(date), today);
        return !isBeforeToday;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: DateService, deps: [{ token: i3.I18nService }, { token: i2$2.ArrayHelpersService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: DateService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: DateService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: i3.I18nService }, { type: i2$2.ArrayHelpersService }] });

class ConvertToDatePipe {
    constructor(dateService) {
        this.dateService = dateService;
    }
    transform(date) {
        if (date) {
            const valid = this.dateService.isDateValid(new Date(date));
            if (!valid) {
                console.warn('The date passed in is not a valid date instance. Got', date);
            }
            return valid ? new Date(date) : null;
        }
        return null;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: ConvertToDatePipe, deps: [{ token: DateService }], target: i0.ɵɵFactoryTarget.Pipe }); }
    /** @nocollapse */ static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "19.2.10", ngImport: i0, type: ConvertToDatePipe, isStandalone: false, name: "ycConvertToDate" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: ConvertToDatePipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'ycConvertToDate',
                    pure: true,
                    standalone: false
                }]
        }], ctorParameters: () => [{ type: DateService }] });

class DatepickerComponent extends FormControlComponent {
    constructor(formGroup, bsLocaleService, i18n, dateService, formControlService) {
        super(formGroup, formControlService);
        this.formGroup = formGroup;
        this.bsLocaleService = bsLocaleService;
        this.i18n = i18n;
        this.dateService = dateService;
        this.isLocked = false;
        this.hideDateIcon = false;
        this.placeholder = '';
        let lang = this.i18n.language || 'en';
        if (lang === 'en-US') {
            lang = 'en';
        }
        this.bsLocaleService.use(lang);
    }
    ngOnInit() {
        super.ngOnInit();
        if (!this.placeholder) {
            this.placeholder = this.dateService.datePlaceholder;
        }
    }
    _onChangeEvent(value) {
        const isValidDate = !!value ? this.dateService.isDateValid(value) : true;
        if (isValidDate) {
            this.emitChange(value);
        }
        else {
            // If not valid, we shouldn't let it persist
            setTimeout(() => {
                this.emitChange(null);
            }, 0);
        }
    }
    emitChange(value) {
        const wasEmpty = !value;
        const isEmpty = !this._value;
        const emptyChange = wasEmpty && isEmpty;
        if (!emptyChange && !isEqual$1(value, this._value)) {
            super._onChange(value);
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: DatepickerComponent, deps: [{ token: i5$1.FormGroupDirective, optional: true }, { token: i2.BsLocaleService }, { token: i3.I18nService }, { token: DateService }, { token: i5.FormControlService }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.2.10", type: DatepickerComponent, isStandalone: false, selector: "yc-datepicker", inputs: { isLocked: "isLocked", hideDateIcon: "hideDateIcon", placeholder: "placeholder" }, usesInheritance: true, ngImport: i0, template: "<div class=\"form-group\"\n  [class.mb-0]=\"noMarginBottom\"\n  [class.ng-invalid]=\"!!(error || customError) && isDirty\">\n<!--\n  .yc-was-invalid - this class needs to be added to the form-group\n  when the input becomes ng-valid after being ng-invalid\n  (ignoring the inital state of .ng-invalid.ng-pristine).\n  It then needs to be removed when the user leaves the input.\n-->\n  <yc-form-label\n    [srOnly]=\"srOnlyLabel\"\n    [name]=\"name\"\n    [label]=\"label\"\n    [description]=\"description\"\n    [tooltipText]=\"tooltipText\"\n    [popoverTemplate]=\"popoverTemplate\"\n    [showQuestionMarkForTooltip]=\"showQuestionMarkForTooltip\"\n    [asteriskForRequired]=\"addRequiredAsterisk\"\n    [customIcon]=\"customLabelIcon\"\n    [customIconTooltip]=\"customLabelIconTooltip\"\n    [customIconClass]=\"customLabelIconClass\">\n  </yc-form-label>\n\n  <div class=\"form-input-wrapper\">\n    <input\n      [disabled]=\"disabled || control.disabled\"\n      type=\"text\"\n      [id]=\"name\"\n      [attr.aria-required]=\"addRequiredAsterisk\"\n      [tabIndex]=\"tabIndex\"\n      class=\"yc-component form-control\"\n      [placeholder]=\"placeholder\"\n      bsDatepicker\n      #dp=\"bsDatepicker\"\n      [bsValue]=\"_value | ycConvertToDate\"\n      [bsConfig]=\"{ \n        showWeekNumbers: false,\n        isAnimated: true,\n        adaptivePosition: true\n      }\"\n      (bsValueChange)=\"_onChangeEvent($event)\"\n      (focus)=\"_onFocus($event)\"\n      (blur)=\"onBlur.emit()\">\n      <div class=\"yc-input-icon-right\">\n        <yc-button *ngIf=\"!hideDateIcon\"\n          [link]=\"true\"\n          class=\"yc-right-input-icon\"\n          [fontAwesomeIcon]=\"'calendar'\"\n          [tooltipText]=\"'common:textOpenCalendar' | ycI18n: 'Open calendar'\"\n          (onClick)=\"(disabled || control.disabled) ? '' : dp.show()\">\n        </yc-button>\n        <yc-fa *ngIf=\"isLocked\" \n          class=\"yc-input-status-icon\"\n          icon=\"lock\">\n        </yc-fa>\n        <yc-fa *ngIf=\"control.status === 'PENDING'\"\n          icon=\"refresh fa-spin\">\n        </yc-fa>\n      </div>\n  </div>\n\n  <yc-form-help-or-error\n    [error]=\"error\"\n    [customError]=\"customError\"\n    [showError]=\"showError\"\n    [showHelp]=\"showHelp\"\n    [help]=\"help\"\n    [helpTextClass]=\"helpTextClass\">\n  </yc-form-help-or-error>\n</div>\n", styles: [".form-group .yc-input-icon-right .yc-right-input-icon{display:inline;position:absolute;top:48%;right:.5rem;transform:translate(-50%,-50%)}.form-group .yc-input-icon-right input{padding-right:2rem}\n"], dependencies: [{ kind: "directive", type: i2.BsDatepickerDirective, selector: "[bsDatepicker]", inputs: ["placement", "triggers", "outsideClick", "container", "outsideEsc", "isDisabled", "minDate", "maxDate", "ignoreMinMaxErrors", "minMode", "daysDisabled", "datesDisabled", "datesEnabled", "dateCustomClasses", "dateTooltipTexts", "isOpen", "bsValue", "bsConfig"], outputs: ["onShown", "onHidden", "bsValueChange"], exportAs: ["bsDatepicker"] }, { kind: "directive", type: i2.BsDatepickerInputDirective, selector: "input[bsDatepicker]" }, { kind: "directive", type: i2$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i5.FormLabelComponent, selector: "yc-form-label", inputs: ["name", "label", "srOnly", "description", "tabIndex", "cursorStyle", "tooltipText", "popoverTemplate", "showQuestionMarkForTooltip", "asteriskForRequired", "forRadioButtons", "customIcon", "customIconTooltip", "customIconClass", "forFileUpload", "triggerUpload"] }, { kind: "component", type: i5.FormHelpOrErrorComponent, selector: "yc-form-help-or-error", inputs: ["error", "customError", "showError", "showHelp", "help", "helpTextClass"] }, { kind: "component", type: i4.FontAwesomeComponent, selector: "yc-fa", inputs: ["color", "icon", "tooltipText", "popoverTemplate", "light", "regular", "solid"], outputs: ["onClick"] }, { kind: "component", type: i8.ButtonComponent, selector: "yc-button", inputs: ["tabIndex", "disabled", "size", "fontSize", "buttonType", "primary", "link", "linkPath", "icon", "secondary", "textDanger", "textWarning", "textPrimary", "textSuccess", "borderOnHover", "noClick", "badgeValue", "value", "ariaDescribedBy", "minWidth", "alignTop", "tooltipText", "popoverTemplate", "container", "popoverContext", "popoverIsOpen", "popoverOutsideClickToClose", "placement", "adaptivePosition", "langKey", "defaultText", "translatedText", "fontAwesomeIcon", "isDropdownButton", "isFooterButton", "dropdownDirection", "dropdownActions", "isDropdownToggle", "isSplitDropdownToggle", "preventClickTracking", "leftAlignLinkText", "analyticsEventName", "customColor", "buttonElementId", "includeExpandedAria", "ariaExpanded"], outputs: ["onClick", "popoverIsOpenChange", "onPopoverReady", "onPopoverClick"] }, { kind: "pipe", type: i3.I18nPipe, name: "ycI18n" }, { kind: "pipe", type: ConvertToDatePipe, name: "ycConvertToDate" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: DatepickerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'yc-datepicker', standalone: false, template: "<div class=\"form-group\"\n  [class.mb-0]=\"noMarginBottom\"\n  [class.ng-invalid]=\"!!(error || customError) && isDirty\">\n<!--\n  .yc-was-invalid - this class needs to be added to the form-group\n  when the input becomes ng-valid after being ng-invalid\n  (ignoring the inital state of .ng-invalid.ng-pristine).\n  It then needs to be removed when the user leaves the input.\n-->\n  <yc-form-label\n    [srOnly]=\"srOnlyLabel\"\n    [name]=\"name\"\n    [label]=\"label\"\n    [description]=\"description\"\n    [tooltipText]=\"tooltipText\"\n    [popoverTemplate]=\"popoverTemplate\"\n    [showQuestionMarkForTooltip]=\"showQuestionMarkForTooltip\"\n    [asteriskForRequired]=\"addRequiredAsterisk\"\n    [customIcon]=\"customLabelIcon\"\n    [customIconTooltip]=\"customLabelIconTooltip\"\n    [customIconClass]=\"customLabelIconClass\">\n  </yc-form-label>\n\n  <div class=\"form-input-wrapper\">\n    <input\n      [disabled]=\"disabled || control.disabled\"\n      type=\"text\"\n      [id]=\"name\"\n      [attr.aria-required]=\"addRequiredAsterisk\"\n      [tabIndex]=\"tabIndex\"\n      class=\"yc-component form-control\"\n      [placeholder]=\"placeholder\"\n      bsDatepicker\n      #dp=\"bsDatepicker\"\n      [bsValue]=\"_value | ycConvertToDate\"\n      [bsConfig]=\"{ \n        showWeekNumbers: false,\n        isAnimated: true,\n        adaptivePosition: true\n      }\"\n      (bsValueChange)=\"_onChangeEvent($event)\"\n      (focus)=\"_onFocus($event)\"\n      (blur)=\"onBlur.emit()\">\n      <div class=\"yc-input-icon-right\">\n        <yc-button *ngIf=\"!hideDateIcon\"\n          [link]=\"true\"\n          class=\"yc-right-input-icon\"\n          [fontAwesomeIcon]=\"'calendar'\"\n          [tooltipText]=\"'common:textOpenCalendar' | ycI18n: 'Open calendar'\"\n          (onClick)=\"(disabled || control.disabled) ? '' : dp.show()\">\n        </yc-button>\n        <yc-fa *ngIf=\"isLocked\" \n          class=\"yc-input-status-icon\"\n          icon=\"lock\">\n        </yc-fa>\n        <yc-fa *ngIf=\"control.status === 'PENDING'\"\n          icon=\"refresh fa-spin\">\n        </yc-fa>\n      </div>\n  </div>\n\n  <yc-form-help-or-error\n    [error]=\"error\"\n    [customError]=\"customError\"\n    [showError]=\"showError\"\n    [showHelp]=\"showHelp\"\n    [help]=\"help\"\n    [helpTextClass]=\"helpTextClass\">\n  </yc-form-help-or-error>\n</div>\n", styles: [".form-group .yc-input-icon-right .yc-right-input-icon{display:inline;position:absolute;top:48%;right:.5rem;transform:translate(-50%,-50%)}.form-group .yc-input-icon-right input{padding-right:2rem}\n"] }]
        }], ctorParameters: () => [{ type: i5$1.FormGroupDirective, decorators: [{
                    type: Optional
                }] }, { type: i2.BsLocaleService }, { type: i3.I18nService }, { type: DateService }, { type: i5.FormControlService }], propDecorators: { isLocked: [{
                type: Input
            }], hideDateIcon: [{
                type: Input
            }], placeholder: [{
                type: Input
            }] } });

class DependendDatesComponent {
    get isDaily() {
        return this.formGroup.value.frequency === Frequency.Daily;
    }
    constructor(dateService) {
        this.dateService = dateService;
        this.isAM = true;
        this.hideTimeSelection = false;
        this.onIsAmChange = new EventEmitter();
        this.onDatesChange = new EventEmitter();
        this.Frequencies = Frequency;
        this.frequencyOptions = this.dateService.getFrequencyOptions();
        this.weekOptions = this.dateService.getWeekOptions();
        this.monthOptions = this.dateService.getMonthOptions();
        this.dayOfMonthOptions = this.dateService.getDayOfMonthOptions();
        this.dayOfWeekOptions = this.dateService.getDayOfTheWeekOptions();
        this.hourOptions = this.dateService.getHourOptions();
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: DependendDatesComponent, deps: [{ token: DateService }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.2.10", type: DependendDatesComponent, isStandalone: false, selector: "yc-dependent-dates", inputs: { formGroup: "formGroup", isAM: "isAM", frequencyLabel: "frequencyLabel", frequencyHelpText: "frequencyHelpText", hoursHelpText: "hoursHelpText", hideTimeSelection: "hideTimeSelection" }, outputs: { onIsAmChange: "onIsAmChange", onDatesChange: "onDatesChange" }, ngImport: i0, template: "<!-- Labels - done here because the alignment of the row becomes off with mixed labels and help text -->\n<div class=\"d-flex\">\n  <div [class.flex-basis-49]=\"!formGroup.value.frequency\" \n    [class.flex-basis-26]=\"formGroup.value.frequency && !isDaily\"\n    [class.flex-basis-50]=\"isDaily && !hideTimeSelection\">\n    {{ frequencyLabel }}\n  </div>\n  <ng-container *ngIf=\"!!formGroup.value.frequency\">\n    <div *ngIf=\"!isDaily\"\n      class=\"flex-basis-24\">\n      <yc-i18n\n        key=\"common:textRepeats\"\n        defaultValue=\"repeats\">\n      </yc-i18n>\n    </div>\n    <div *ngIf=\"!isDaily\"\n      class=\"flex-basis-24 ms-1\">\n      <yc-i18n\n        key=\"common:textOnEvery\"\n        defaultValue=\"on every\">\n      </yc-i18n>\n    </div>\n    <div *ngIf=\"!hideTimeSelection\"\n      class=\"ms-1\" \n      [class.flex-basis-46]=\"isDaily\"\n      [class.flex-basis-24]=\"!isDaily\">\n      <yc-i18n\n        key=\"common:textAtLowercase\"\n        defaultValue=\"at\">\n      </yc-i18n>\n    </div>\n    <div class=\"flex-basis-2\"></div>\n  </ng-container>\n</div>\n\n<div class=\"d-flex align-items-center\">\n  <!-- Frequency -->\n  <div class=\"me-2\"\n    [class.flex-basis-49]=\"!formGroup.value.frequency\" \n    [class.flex-basis-24]=\"formGroup.value.frequency && !isDaily\"\n    [class.flex-basis-50]=\"isDaily\">\n    <yc-typeahead-select\n      name=\"frequency\"\n      [showClear]=\"false\"\n      [items]=\"frequencyOptions\"\n      (onChange)=\"onDatesChange.emit()\">\n    </yc-typeahead-select>\n  </div>\n\n  <!-- IF Weekly-->\n  <ng-container *ngIf=\"formGroup.value.frequency === Frequencies.Weekly\">\n    <!-- Week -->\n    <div class=\"flex-basis-24 me-2\">\n      <yc-typeahead-select\n        name=\"week\"\n        [showClear]=\"false\"\n        [items]=\"weekOptions\"\n        (onChange)=\"onDatesChange.emit()\">\n      </yc-typeahead-select>\n    </div>\n\n    <!-- Day of Week -->\n    <div class=\"flex-basis-24 me-2\">\n      <yc-typeahead-select\n        name=\"dayOfWeek\"\n        [showClear]=\"false\"\n        [items]=\"dayOfWeekOptions\"\n        (onChange)=\"onDatesChange.emit()\">\n      </yc-typeahead-select>\n    </div>\n  </ng-container>\n\n  <!-- IF Monthly-->\n  <ng-container *ngIf=\"formGroup.value.frequency === Frequencies.Monthly\">\n    <!-- Month -->\n    <div class=\"flex-basis-24 me-2\">\n      <yc-typeahead-select\n        name=\"month\"\n        [showClear]=\"false\"\n        [items]=\"monthOptions\"\n        (onChange)=\"onDatesChange.emit()\">\n      </yc-typeahead-select>\n    </div>\n\n    <!-- Day of Month -->\n    <div class=\"flex-basis-24 me-2\">\n      <yc-typeahead-select\n        name=\"dayOfMonth\"\n        [showClear]=\"false\"\n        [items]=\"dayOfMonthOptions\"\n        (onChange)=\"onDatesChange.emit()\">\n      </yc-typeahead-select>\n    </div>\n\n  </ng-container>\n  \n  <ng-container *ngIf=\"formGroup.value.frequency && !hideTimeSelection\">\n    <!-- Hour -->\n    <div [class.flex-basis-46]=\"isDaily\"\n      [class.flex-basis-24]=\"!isDaily\">\n      <yc-typeahead-select\n        name=\"hours\"\n        [showClear]=\"false\"\n        [items]=\"hourOptions\"\n        (onChange)=\"onDatesChange.emit()\">\n      </yc-typeahead-select>\n    </div>\n\n    <!-- AM / PM -->\n    <div class=\"flex-basis-2 am-pm\" \n      (click)=\"isAM = !isAM; onIsAmChange.emit(isAM)\">\n      <yc-i18n\n        class=\"text-link\"\n        [key]=\"isAM ? 'common:textAM' : 'common:textPM'\"\n        [defaultValue]=\"isAM ? 'AM' : 'PM'\">\n      </yc-i18n>\n    </div>\n  </ng-container>\n</div>\n\n\n<!-- Help text - done here because the alignment of the row becomes off with mixed labels and help text -->\n<div class=\"d-flex\">\n  <div [class.flex-basis-49]=\"!formGroup.value.frequency\" \n    [class.flex-basis-24]=\"formGroup.value.frequency && !isDaily\"\n    [class.flex-basis-50]=\"isDaily\">\n    <small>\n      {{ frequencyHelpText }}\n    </small>\n  </div>\n  <ng-container *ngIf=\"!!formGroup.value.frequency\">\n    <div *ngIf=\"!isDaily\"\n      class=\"flex-basis-24\">\n    </div>\n    <div *ngIf=\"!isDaily\"\n      class=\"flex-basis-24\">\n    </div>\n    <div class=\"ms-2\" *ngIf=\"!hideTimeSelection\"\n      [class.flex-basis-46]=\"isDaily\"\n      [class.flex-basis-24]=\"!isDaily\">\n      <small>\n        {{ hoursHelpText }}\n      </small>\n    </div>\n    <div class=\"flex-basis-2\"></div>\n  </ng-container>\n</div>\n", styles: [".flex-basis-24{flex-basis:24%}.flex-basis-2{flex-basis:2%}.flex-basis-26{flex-basis:26%}.flex-basis-48{flex-basis:48%}.flex-basis-46{flex-basis:46%}.flex-basis-49{flex-basis:49.5%}.am-pm{font-size:.9rem;margin-left:1rem;cursor:pointer}\n"], dependencies: [{ kind: "directive", type: i2$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i3.I18nComponent, selector: "yc-i18n", inputs: ["key", "defaultValue", "context", "transform"] }, { kind: "component", type: i4$1.TypeaheadSelectComponent, selector: "yc-typeahead-select", inputs: ["items", "supportsNumericCollection", "numericCollectionType", "dropdownPosition", "notFoundText", "multi", "formatAsArray", "hideBorder", "placeholder", "isLocked", "noBorderRadius", "useEmptyArray", "loading", "useLabelTemplate", "showSelectAllThatApplyHelpText"], outputs: ["onItemAdded", "onItemRemoved"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: DependendDatesComponent, decorators: [{
            type: Component,
            args: [{ selector: 'yc-dependent-dates', standalone: false, template: "<!-- Labels - done here because the alignment of the row becomes off with mixed labels and help text -->\n<div class=\"d-flex\">\n  <div [class.flex-basis-49]=\"!formGroup.value.frequency\" \n    [class.flex-basis-26]=\"formGroup.value.frequency && !isDaily\"\n    [class.flex-basis-50]=\"isDaily && !hideTimeSelection\">\n    {{ frequencyLabel }}\n  </div>\n  <ng-container *ngIf=\"!!formGroup.value.frequency\">\n    <div *ngIf=\"!isDaily\"\n      class=\"flex-basis-24\">\n      <yc-i18n\n        key=\"common:textRepeats\"\n        defaultValue=\"repeats\">\n      </yc-i18n>\n    </div>\n    <div *ngIf=\"!isDaily\"\n      class=\"flex-basis-24 ms-1\">\n      <yc-i18n\n        key=\"common:textOnEvery\"\n        defaultValue=\"on every\">\n      </yc-i18n>\n    </div>\n    <div *ngIf=\"!hideTimeSelection\"\n      class=\"ms-1\" \n      [class.flex-basis-46]=\"isDaily\"\n      [class.flex-basis-24]=\"!isDaily\">\n      <yc-i18n\n        key=\"common:textAtLowercase\"\n        defaultValue=\"at\">\n      </yc-i18n>\n    </div>\n    <div class=\"flex-basis-2\"></div>\n  </ng-container>\n</div>\n\n<div class=\"d-flex align-items-center\">\n  <!-- Frequency -->\n  <div class=\"me-2\"\n    [class.flex-basis-49]=\"!formGroup.value.frequency\" \n    [class.flex-basis-24]=\"formGroup.value.frequency && !isDaily\"\n    [class.flex-basis-50]=\"isDaily\">\n    <yc-typeahead-select\n      name=\"frequency\"\n      [showClear]=\"false\"\n      [items]=\"frequencyOptions\"\n      (onChange)=\"onDatesChange.emit()\">\n    </yc-typeahead-select>\n  </div>\n\n  <!-- IF Weekly-->\n  <ng-container *ngIf=\"formGroup.value.frequency === Frequencies.Weekly\">\n    <!-- Week -->\n    <div class=\"flex-basis-24 me-2\">\n      <yc-typeahead-select\n        name=\"week\"\n        [showClear]=\"false\"\n        [items]=\"weekOptions\"\n        (onChange)=\"onDatesChange.emit()\">\n      </yc-typeahead-select>\n    </div>\n\n    <!-- Day of Week -->\n    <div class=\"flex-basis-24 me-2\">\n      <yc-typeahead-select\n        name=\"dayOfWeek\"\n        [showClear]=\"false\"\n        [items]=\"dayOfWeekOptions\"\n        (onChange)=\"onDatesChange.emit()\">\n      </yc-typeahead-select>\n    </div>\n  </ng-container>\n\n  <!-- IF Monthly-->\n  <ng-container *ngIf=\"formGroup.value.frequency === Frequencies.Monthly\">\n    <!-- Month -->\n    <div class=\"flex-basis-24 me-2\">\n      <yc-typeahead-select\n        name=\"month\"\n        [showClear]=\"false\"\n        [items]=\"monthOptions\"\n        (onChange)=\"onDatesChange.emit()\">\n      </yc-typeahead-select>\n    </div>\n\n    <!-- Day of Month -->\n    <div class=\"flex-basis-24 me-2\">\n      <yc-typeahead-select\n        name=\"dayOfMonth\"\n        [showClear]=\"false\"\n        [items]=\"dayOfMonthOptions\"\n        (onChange)=\"onDatesChange.emit()\">\n      </yc-typeahead-select>\n    </div>\n\n  </ng-container>\n  \n  <ng-container *ngIf=\"formGroup.value.frequency && !hideTimeSelection\">\n    <!-- Hour -->\n    <div [class.flex-basis-46]=\"isDaily\"\n      [class.flex-basis-24]=\"!isDaily\">\n      <yc-typeahead-select\n        name=\"hours\"\n        [showClear]=\"false\"\n        [items]=\"hourOptions\"\n        (onChange)=\"onDatesChange.emit()\">\n      </yc-typeahead-select>\n    </div>\n\n    <!-- AM / PM -->\n    <div class=\"flex-basis-2 am-pm\" \n      (click)=\"isAM = !isAM; onIsAmChange.emit(isAM)\">\n      <yc-i18n\n        class=\"text-link\"\n        [key]=\"isAM ? 'common:textAM' : 'common:textPM'\"\n        [defaultValue]=\"isAM ? 'AM' : 'PM'\">\n      </yc-i18n>\n    </div>\n  </ng-container>\n</div>\n\n\n<!-- Help text - done here because the alignment of the row becomes off with mixed labels and help text -->\n<div class=\"d-flex\">\n  <div [class.flex-basis-49]=\"!formGroup.value.frequency\" \n    [class.flex-basis-24]=\"formGroup.value.frequency && !isDaily\"\n    [class.flex-basis-50]=\"isDaily\">\n    <small>\n      {{ frequencyHelpText }}\n    </small>\n  </div>\n  <ng-container *ngIf=\"!!formGroup.value.frequency\">\n    <div *ngIf=\"!isDaily\"\n      class=\"flex-basis-24\">\n    </div>\n    <div *ngIf=\"!isDaily\"\n      class=\"flex-basis-24\">\n    </div>\n    <div class=\"ms-2\" *ngIf=\"!hideTimeSelection\"\n      [class.flex-basis-46]=\"isDaily\"\n      [class.flex-basis-24]=\"!isDaily\">\n      <small>\n        {{ hoursHelpText }}\n      </small>\n    </div>\n    <div class=\"flex-basis-2\"></div>\n  </ng-container>\n</div>\n", styles: [".flex-basis-24{flex-basis:24%}.flex-basis-2{flex-basis:2%}.flex-basis-26{flex-basis:26%}.flex-basis-48{flex-basis:48%}.flex-basis-46{flex-basis:46%}.flex-basis-49{flex-basis:49.5%}.am-pm{font-size:.9rem;margin-left:1rem;cursor:pointer}\n"] }]
        }], ctorParameters: () => [{ type: DateService }], propDecorators: { formGroup: [{
                type: Input
            }], isAM: [{
                type: Input
            }], frequencyLabel: [{
                type: Input
            }], frequencyHelpText: [{
                type: Input
            }], hoursHelpText: [{
                type: Input
            }], hideTimeSelection: [{
                type: Input
            }], onIsAmChange: [{
                type: Output
            }], onDatesChange: [{
                type: Output
            }] } });

class TimeInputComponent extends FormControlComponent {
    constructor() {
        super(...arguments);
        this.disabled = false;
    }
    ngOnInit() {
        super.ngOnInit();
        if (this._value === null) {
            this._internalValue = null;
        }
        else {
            this._internalValue = new Date(this._value);
        }
    }
    _onChange(value) {
        const parsedValue = new Date(value);
        super._onChange(parsedValue);
        this._internalValue = value;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: TimeInputComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.2.10", type: TimeInputComponent, isStandalone: false, selector: "yc-time-input", inputs: { disabled: "disabled" }, usesInheritance: true, ngImport: i0, template: "<div class=\"form-group\"\n  [class.mb-0]=\"noMarginBottom\"\n  [class.ng-invalid]=\"!!(error || customError) && isDirty\">\n  <!--\n  .yc-was-invalid - this class needs to be added to the form-group\n  when the input becomes ng-valid after being ng-invalid\n  (ignoring the inital state of .ng-invalid.ng-pristine).\n  It then needs to be removed when the user leaves the input.\n-->\n  <yc-form-label\n    [srOnly]=\"srOnlyLabel\"\n    [name]=\"name\"\n    [label]=\"label\"\n    [description]=\"description\"\n    [tooltipText]=\"tooltipText\"\n    [popoverTemplate]=\"popoverTemplate\"\n    [showQuestionMarkForTooltip]=\"showQuestionMarkForTooltip\"\n    [asteriskForRequired]=\"addRequiredAsterisk\"\n    [customIcon]=\"customLabelIcon\"\n    [customIconTooltip]=\"customLabelIconTooltip\"\n    [customIconClass]=\"customLabelIconClass\">\n  </yc-form-label>\n  <div class=\"form-input-wrapper no-padding\">\n  <timepicker\n    [disabled]=\"disabled || control?.disabled\"\n    [ngModel]=\"_internalValue\"\n    [minuteStep]=\"1\"\n    (ngModelChange)=\"_onChange($event)\">\n  </timepicker>\n  \n  <yc-form-help-or-error\n    [error]=\"error\"\n    [customError]=\"customError\"\n    [showError]=\"showError\"\n    [showHelp]=\"showHelp\"\n    [help]=\"help\"\n    [helpTextClass]=\"helpTextClass\">\n  </yc-form-help-or-error>\n</div>", styles: [""], dependencies: [{ kind: "component", type: i1.TimepickerComponent, selector: "timepicker", inputs: ["hourStep", "minuteStep", "secondsStep", "readonlyInput", "disabled", "mousewheel", "arrowkeys", "showSpinners", "showMeridian", "showMinutes", "showSeconds", "meridians", "min", "max", "hoursPlaceholder", "minutesPlaceholder", "secondsPlaceholder"], outputs: ["isValid", "meridianChange"] }, { kind: "component", type: i5.FormLabelComponent, selector: "yc-form-label", inputs: ["name", "label", "srOnly", "description", "tabIndex", "cursorStyle", "tooltipText", "popoverTemplate", "showQuestionMarkForTooltip", "asteriskForRequired", "forRadioButtons", "customIcon", "customIconTooltip", "customIconClass", "forFileUpload", "triggerUpload"] }, { kind: "component", type: i5.FormHelpOrErrorComponent, selector: "yc-form-help-or-error", inputs: ["error", "customError", "showError", "showHelp", "help", "helpTextClass"] }, { kind: "directive", type: i5$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i5$1.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: TimeInputComponent, decorators: [{
            type: Component,
            args: [{ selector: 'yc-time-input', standalone: false, template: "<div class=\"form-group\"\n  [class.mb-0]=\"noMarginBottom\"\n  [class.ng-invalid]=\"!!(error || customError) && isDirty\">\n  <!--\n  .yc-was-invalid - this class needs to be added to the form-group\n  when the input becomes ng-valid after being ng-invalid\n  (ignoring the inital state of .ng-invalid.ng-pristine).\n  It then needs to be removed when the user leaves the input.\n-->\n  <yc-form-label\n    [srOnly]=\"srOnlyLabel\"\n    [name]=\"name\"\n    [label]=\"label\"\n    [description]=\"description\"\n    [tooltipText]=\"tooltipText\"\n    [popoverTemplate]=\"popoverTemplate\"\n    [showQuestionMarkForTooltip]=\"showQuestionMarkForTooltip\"\n    [asteriskForRequired]=\"addRequiredAsterisk\"\n    [customIcon]=\"customLabelIcon\"\n    [customIconTooltip]=\"customLabelIconTooltip\"\n    [customIconClass]=\"customLabelIconClass\">\n  </yc-form-label>\n  <div class=\"form-input-wrapper no-padding\">\n  <timepicker\n    [disabled]=\"disabled || control?.disabled\"\n    [ngModel]=\"_internalValue\"\n    [minuteStep]=\"1\"\n    (ngModelChange)=\"_onChange($event)\">\n  </timepicker>\n  \n  <yc-form-help-or-error\n    [error]=\"error\"\n    [customError]=\"customError\"\n    [showError]=\"showError\"\n    [showHelp]=\"showHelp\"\n    [help]=\"help\"\n    [helpTextClass]=\"helpTextClass\">\n  </yc-form-help-or-error>\n</div>" }]
        }], propDecorators: { disabled: [{
                type: Input
            }] } });

class DependentDatesSentencePipe {
    constructor(dateService) {
        this.dateService = dateService;
    }
    transform(frequency, week, month, dayOfMonth, dayOfWeek, isAM, hours, timezone) {
        return this.dateService.getDependentDatesSentence(frequency, week, month, dayOfMonth, dayOfWeek, isAM, hours, timezone);
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: DependentDatesSentencePipe, deps: [{ token: DateService }], target: i0.ɵɵFactoryTarget.Pipe }); }
    /** @nocollapse */ static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "19.2.10", ngImport: i0, type: DependentDatesSentencePipe, isStandalone: false, name: "ycDependentDatesSentence" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: DependentDatesSentencePipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'ycDependentDatesSentence',
                    standalone: false
                }]
        }], ctorParameters: () => [{ type: DateService }] });

class DisplayDateDistanceFromNowPipe {
    constructor(dateService) {
        this.dateService = dateService;
    }
    transform(date) {
        if (!!date) {
            return this.dateService.getDateDistanceFromNow(date);
        }
        return '';
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: DisplayDateDistanceFromNowPipe, deps: [{ token: DateService }], target: i0.ɵɵFactoryTarget.Pipe }); }
    /** @nocollapse */ static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "19.2.10", ngImport: i0, type: DisplayDateDistanceFromNowPipe, isStandalone: false, name: "ycDisplayDateDistanceFromNow" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: DisplayDateDistanceFromNowPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'ycDisplayDateDistanceFromNow',
                    standalone: false
                }]
        }], ctorParameters: () => [{ type: DateService }] });

class FormatDatePipe {
    constructor(dateService) {
        this.dateService = dateService;
    }
    transform(date, format = DATE_FORMAT) {
        return this.dateService.formatDate(date, format);
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: FormatDatePipe, deps: [{ token: DateService }], target: i0.ɵɵFactoryTarget.Pipe }); }
    /** @nocollapse */ static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "19.2.10", ngImport: i0, type: FormatDatePipe, isStandalone: false, name: "ycFormatDate" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: FormatDatePipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'ycFormatDate',
                    standalone: false
                }]
        }], ctorParameters: () => [{ type: DateService }] });

class StartOfDayDateFormatterPipe {
    constructor(dateService) {
        this.dateService = dateService;
    }
    transform(date, format = DATE_FORMAT, isStart = true) {
        return this.dateService.getStartOrEndOfDayInUtcFormatted(date, isStart, format);
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: StartOfDayDateFormatterPipe, deps: [{ token: DateService }], target: i0.ɵɵFactoryTarget.Pipe }); }
    /** @nocollapse */ static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "19.2.10", ngImport: i0, type: StartOfDayDateFormatterPipe, isStandalone: false, name: "ycStartOfDayDateFormatter" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: StartOfDayDateFormatterPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'ycStartOfDayDateFormatter',
                    standalone: false
                }]
        }], ctorParameters: () => [{ type: DateService }] });

class DateModule {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: DateModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.2.10", ngImport: i0, type: DateModule, declarations: [DatepickerComponent,
            DateRangePickerComponent,
            ConvertToDatePipe,
            DependentDatesSentencePipe,
            DisplayDateDistanceFromNowPipe,
            FormatDatePipe,
            StartOfDayDateFormatterPipe,
            DependendDatesComponent,
            TimeInputComponent], imports: [i2.BsDatepickerModule, i1.TimepickerModule, CommonModule,
            CoreFormsModule,
            IconsModule,
            ButtonModule,
            I18nModule,
            TypeaheadSelectModule,
            FormsModule], exports: [DatepickerComponent,
            DateRangePickerComponent,
            ConvertToDatePipe,
            DependentDatesSentencePipe,
            DisplayDateDistanceFromNowPipe,
            FormatDatePipe,
            StartOfDayDateFormatterPipe,
            DependendDatesComponent,
            TimeInputComponent] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: DateModule, imports: [BsDatepickerModule.forRoot(),
            TimepickerModule.forRoot(),
            CommonModule,
            CoreFormsModule,
            IconsModule,
            ButtonModule,
            I18nModule,
            TypeaheadSelectModule,
            FormsModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: DateModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        BsDatepickerModule.forRoot(),
                        TimepickerModule.forRoot(),
                        CommonModule,
                        CoreFormsModule,
                        IconsModule,
                        ButtonModule,
                        I18nModule,
                        TypeaheadSelectModule,
                        FormsModule
                    ],
                    declarations: [
                        DatepickerComponent,
                        DateRangePickerComponent,
                        ConvertToDatePipe,
                        DependentDatesSentencePipe,
                        DisplayDateDistanceFromNowPipe,
                        FormatDatePipe,
                        StartOfDayDateFormatterPipe,
                        DependendDatesComponent,
                        TimeInputComponent
                    ],
                    exports: [
                        DatepickerComponent,
                        DateRangePickerComponent,
                        ConvertToDatePipe,
                        DependentDatesSentencePipe,
                        DisplayDateDistanceFromNowPipe,
                        FormatDatePipe,
                        StartOfDayDateFormatterPipe,
                        DependendDatesComponent,
                        TimeInputComponent
                    ]
                }]
        }] });

function DateRangeValidator(startDateName = 'startDate', endDateName = 'endDate') {
    return (group) => {
        let returnVal = null;
        const start = group.get(startDateName).value;
        const end = group.get(endDateName).value;
        const isSameOrBefore = isSameSecond(start, end) || isBefore(end, start);
        if (isSameOrBefore) {
            returnVal = {
                [endDateName]: {
                    startEndDateInvalid: 'End date must be after start'
                }
            };
        }
        return returnVal;
    };
}

function DateTimeRangeValidator(startDateName = 'startDate', endDateName = 'endDate', startTimeName = 'startTime', endTimeName = 'endTime') {
    return (group) => {
        let returnVal = null;
        const startDate = group.get(startDateName).value;
        const startTime = group.get(startTimeName).value;
        const endDate = group.get(endDateName).value;
        const endTime = group.get(endTimeName).value;
        const start = set(new Date(startDate), {
            hours: getHours(startTime),
            minutes: getMinutes(new Date(startTime))
        });
        const end = set(new Date(endDate), {
            hours: getHours(endTime),
            minutes: getMinutes(endTime)
        });
        const isSameOrBefore = isSameSecond(start, end) || isBefore(end, start);
        if (isSameOrBefore) {
            returnVal = {
                [endDateName]: {
                    endAfterStart: {
                        i18nKey: 'common:textPleaseEnterEndDateAfterStart',
                        defaultValue: 'End date must be after start date'
                    }
                }
            };
        }
        return returnVal;
    };
}

/**
 * Generated bundle index. Do not edit.
 */

export { ConvertToDatePipe, DATE_FORMAT, DATE_TIME_FORMAT, DateModule, DateRangePickerComponent, DateRangeValidator, DateService, DateTimeRangeValidator, DatepickerComponent, DaysOfWeek, DependendDatesComponent, DependentDatesSentencePipe, DisplayDateDistanceFromNowPipe, FormatDatePipe, Frequency, StartOfDayDateFormatterPipe, TIMESTAMP_FORMAT, TimeInputComponent };
